import React, { useEffect, useState } from "react";
import styles from "../Profile/Profile.module.css";
import multipleEntry from "../../assests/popup/multipleEntry.svg";
import { useLocation, useNavigate } from "react-router";
import { createSearchParams } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";

function MultipleEntryPopup({ buttonColor, setMultipleEntryPopup }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { searchParams } = useUserAuth();
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className="popupBackground fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center z-10">
      <div className={styles.deteleme}>
        <img
          src={multipleEntry}
          alt=""
          className="w-[56px] h-[56px] mb-[24px]"
        />
        <p
          className="text-regular-medium px-[20px] mb-[16px]"
          style={{ color: buttonColor }}
        >
          Sorry! You’ve already participated on this contest.
        </p>
        <p className="text-small text-[#CDCDCD] px-[20px]">
          If you want to participate again. Please delete your previous
          participation form this contest.
        </p>
        <div className="seperator my-[20px]" />
        <div className="flex flex-col gap-[16px] w-[100%]">
          <button
            className={styles.Deeleeete}
            onClick={() =>
              navigate(
                {
                  pathname: `/profile`,
                  search: `${
                    searchParams ? createSearchParams(searchParams) : ""
                  }`,
                },
                { state: { previousLocation: location?.pathname } }
              )
            }
          >
            <p className="text-regular-medium">View Profile</p>
          </button>
          <button onClick={() => setMultipleEntryPopup(false)}>
            <p>Cancel</p>
          </button>
        </div>
      </div>
    </div>
  );
}

export default MultipleEntryPopup;
